




































































































import cloneDeep from "lodash/cloneDeep";

import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";

import TitleBar from "@/components/Elements/TitleBar.vue";

import ProductForm from "./ProductForm/ProductForm.vue";
import ProductViewForm from "./ProductViewForm/ProductViewForm.vue";
import ProductTypeViewForm from "./ProductTypeViewForm/ProductTypeViewForm.vue";
import uniq from "lodash/uniq";
import ProductContainerForm from "./ProductContainerForm/ProductContainerForm.vue";
import ProductContainerViewForm from "./ProductContainerViewForm/ProductContainerViewForm.vue";
import Combobox from "@/components/Controls/Combobox.vue";
import ExcelJS from "exceljs";
import {
  exportProductSpecDocx,
  createProductSpecExportOptions
} from "./utils/productSpecExport";
import { openCatalogEntityRoute, openCatalogEntityModal, catalogEntityKindFromRow } from "./utils/openCatalogEntity";
import { shallowProductTypesTree } from "./utils/shallowProductTypesTree";

@Component({
  computed: {
    ...mapState("ubic", ["token", "actor"]),
    ...mapGetters("ubic", ["isAdmin", "isCatalog"]),
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "filter",

      "documents",
      "lastMeta"
    ]),
    ...mapGetters(STORE_KEY, ["productTypesTree"])
  },
  methods: {
    ...mapActions(STORE_KEY, ["exportData"])
  },
  components: {
    TitleBar,
    Combobox
  }
})
export default class ProductCatalog extends Vue {
  opened: any[] = [];

  isPrimeCostModalActive: boolean = false;
  token!: any;

  showColumns: any[] = [];

  /** Optional columns in the picker (Наименование is always shown). */
  columnsList: any[] = [
    { id: "protected_recipe", label: "Защищенная рецептура" },
    { id: "teaser_composition", label: "Промо состав" },
    { id: "composition", label: "Состав полный" },
    { id: "scope", label: "Область применения" },
    { id: "business_scopes", label: "Сфера деятельности" },
    { id: "price_segment_name", label: "Ценовой сегмент" },
    { id: "technology_name", label: "Технология" },
    { id: "cost", label: "Себестоимость" },
    { id: "trade_price", label: "Рекомендованная оптовая цена" },
    { id: "retail_price", label: "Рекомендованная розничная цена" }
  ];

  allColumns: any[] = [
    {
      label: "Наименование",
      id: "name",
      width: 280,
      format: (_value: any, row?: any) => (row && row.name) || ""
    },
    {
      label: "Защищенная рецептура",
      id: "protected_recipe",
      width: 160,
      format: (value: any) => (value ? "Да" : "")
    },
    { label: "Промо состав", id: "teaser_composition", width: 250 },
    { label: "Состав полный", id: "composition", width: 250 },
    { label: "Область применения", id: "scope", width: 200 },
    {
      label: "Сфера деятельности",
      id: "business_scopes",
      width: 200,
      format: (value: any) => {
        if (value && Array.isArray(value) && value.length > 0) {
          return value.map((s: any) => s.name).join(", ");
        }
        return "";
      }
    },
    { label: "Ценовой сегмент", id: "price_segment_name", width: 150 },
    { label: "Технология", id: "technology_name", width: 150 },
    {
      label: "Себестоимость",
      id: "cost",
      width: 180,
      format: (value: any) => (value ? `${parseFloat(value).toFixed(2)} ₽` : "")
    },
    {
      label: "Рекоменд. оптовая цена",
      id: "trade_price",
      width: 180,
      format: (value: any) => (value ? `${parseFloat(value).toFixed(2)} ₽` : "")
    },
    {
      label: "Рекоменд. розничная цена",
      id: "retail_price",
      width: 180,
      format: (value: any) => (value ? `${parseFloat(value).toFixed(2)} ₽` : "")
    }
  ];

  get productTypesColumns() {
    return this.allColumns;
  }

  get defaultOptionalColumns() {
    return [
      "protected_recipe",
      "business_scopes",
      "cost",
      "trade_price",
      "retail_price"
    ];
  }

  get visibleColumns() {
    const nameCol = this.allColumns.find((col: any) => col.id === "name");
    const optionalIds =
      this.showColumns.length > 0
        ? this.showColumns
        : this.defaultOptionalColumns;
    const optional = this.allColumns.filter(
      (col: any) => col.id !== "name" && optionalIds.includes(col.id)
    );
    return nameCol ? [nameCol, ...optional] : optional;
  }

  get filteredProductTypesTree(): any[] {
    const productTypesTree = (this as any).productTypesTree;
    const archiveFiltered = this.filterArchivedItems(productTypesTree);
    return shallowProductTypesTree(archiveFiltered);
  }

  filterArchivedItems(items: any[]): any[] {
    if (!items || !Array.isArray(items)) {
      return [];
    }
    return items
      .map((item: any) => {
        if (item.archived_at) {
          return null;
        }
        if (item.type === "type" || item.type === "parent") {
          return {
            ...item,
            children: this.filterArchivedItems(item.children || [])
          };
        }
        if (item.type === "product" && item.children) {
          return {
            ...item,
            children: this.filterArchivedItems(item.children)
          };
        }
        return item;
      })
      .filter((item: any) => item !== null);
  }

  get titleStack() {
    return ["Каталог продуктов", "Продукты"];
  }

  hasDetailedVisible(row: any) {
    return !!(row.children && row.children.length > 0);
  }

  formatCell(col: any, row: any) {
    const value = row ? row[col.id] : null;
    if (col && typeof col.format === "function") {
      return col.format(value, row);
    }
    return value;
  }

  onTypeRowClick(
    row: any,
    _column: any,
    _rowIndex: number,
    _columnIndex: number,
    event?: MouseEvent
  ) {
    if (!row || row.type !== "type") {
      return;
    }
    const target = event && (event.target as HTMLElement | null);
    if (
      target &&
      target.closest(".detail-cell, .chevron-cell, button, a, .icon")
    ) {
      return;
    }
    this.openCatalogTypeOrParent(row);
  }

  onDetailToggle(row: any, to: string) {
    if (to == "open") {
      this.opened = uniq([...this.opened, row.id]);
    } else {
      this.opened = uniq(this.opened.filter($row => $row.id != row.id));
    }
  }

  sanitizeColumnSelection(columns: any[]): string[] {
    const allowed = new Set(this.columnsList.map((col: any) => col.id));
    return (columns || []).filter((id: any) => allowed.has(id));
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null;
  }

  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [
      this.$route.query.sortField || "name",
      this.$route.query.sortDirection || "asc"
    ];
  }

  get selectedView() {
    return this.$route.query.view || "linked";
  }

  onSort(field: string, direction: string) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction
      }
    });
  }
  private delayFilter: any = null;

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...filter
          }
        });
        this.delayFilter = null;
      }, 3000);
    }
    this.delayFilter = filter;
  }

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.$router.replace({
      query: { ...this.$route.query, page }
    });
  }

  // ---------------------------------------------------------------------------

  openProduct(row: any, type_id: any = null) {
    if (row && row.id && openCatalogEntityRoute(this, row)) {
      return;
    }

    console.debug("[ProductCatalog.openProduct]", {
      type: row && row.type,
      type_id,
      id: row && row.id
    });
    this.$buefy.modal.open({
      component: ProductForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: type_id ? { type_id } : {}
      },
      events: {
        "form-close": () => {
          this.handleParamsChange();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form",
      parent: this
    });
  }

  copyProduct(row: any) {
    this.$store
      .dispatch(`${STORE_KEY}/getProductForCopy`, row.id)
      .then((result: any) => {
        const { document, businessScopes } = result;

        // Подготавливаем данные для копии
        const copyData: any = {
          name: `${document.name} Копия`,
          code: `${document.code}-copy`,
          type_id: document.type_id,
          trade_mark_id: document.trade_mark_id,
          teaser: document.teaser,
          pick_up_product: document.pick_up_product,
          show_in_catalog: document.show_in_catalog,
          business_scope_ids: (businessScopes || []).map(
            (s: any) => s.business_scope_id
          )
        };

        this.$buefy.modal.open({
          component: ProductForm,
          props: {
            isNew: true,
            documentPreview: null,
            initParams: copyData
          },
          events: {
            "form-close": () => {
              this.handleParamsChange();
            }
          },
          hasModalCard: true,
          fullScreen: true,
          customClass: "document-form",
          parent: this
        });
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При копировании возникли проблемы. Попробуйте позже.`
        });
      });
  }

  openProductView(row: any) {
    if (openCatalogEntityRoute(this, row)) {
      return;
    }

    this.$buefy.modal.open({
      component: ProductViewForm,
      props: {
        documentPreview: row
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form",
      parent: this
    });
  }

  openCatalogTypeOrParent(row: any) {
    console.debug("[ProductCatalog.openCatalogTypeOrParent]", {
      id: row && row.id,
      type: row && row.type
    });
    if (openCatalogEntityRoute(this, row)) {
      return;
    }

    const kind = catalogEntityKindFromRow(row);
    if (!kind) {
      return;
    }

    openCatalogEntityModal(this, kind, row.id, {
      parent: this,
      onClose: () => this.handleParamsChange()
    });
  }

  openProductTypeView(row: any) {
    this.openCatalogTypeOrParent(row);
  }

  openProductType(row: any, parent_id: any = null) {
    if (row && row.id) {
      this.openCatalogTypeOrParent(row);
      return;
    }
    this.$buefy.snackbar.open({
      type: "is-info",
      message:
        "Создание типов и родительских продуктов доступно в Справочнике продуктов → Структура"
    });
  }

  openParentProduct(row: any, type_id: any) {
    this.openProductType(row, type_id);
  }

  catalogRowClass(row: any) {
    switch (row.type) {
      case "type":
        return "catalog-row-type";
      case "parent":
        return "catalog-row-parent";
      case "product":
        return "catalog-row-product";
      case "container":
        return "catalog-row-container";
      default:
        return "";
    }
  }

  productArchive(row: any) {
    this.$store
      .dispatch(`${STORE_KEY}/productToArchive`, row.id)
      .then(result => {
        this.$buefy.snackbar.open(`Продукт помечен архивным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        });
      });
  }

  productUnarchive(row: any) {
    this.$store
      .dispatch(`${STORE_KEY}/productToUnarchive`, row.id)
      .then(result => {
        this.$buefy.snackbar.open(`Продукт помечен активным`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        });
      });
  }

  openProductContainerView(row: any) {
    if (openCatalogEntityRoute(this, row)) {
      return;
    }

    this.$buefy.modal.open({
      component: ProductContainerViewForm,
      props: {
        documentPreview: row
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form",
      parent: this
    });
  }

  openProductContainer(row: any, product: any) {
    if (row && row.id && openCatalogEntityRoute(this, row)) {
      return;
    }

    this.$buefy.modal.open({
      component: ProductContainerForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: product
          ? {
              product_id: product.id
            }
          : {}
      },
      events: {
        "form-close": () => {
          this.handleParamsChange();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: "document-form short-form",
      parent: this
    });
  }

  productContainerArchive(row: any) {
    this.$store
      .dispatch(`${STORE_KEY}/productToArchive`, row.id)
      .then(result => {
        this.$buefy.snackbar.open(`Тара помечена архивной`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        });
      });
  }

  productContainerUnarchive(row: any) {
    this.$store
      .dispatch(`${STORE_KEY}/productToUnarchive`, row.id)
      .then(result => {
        this.$buefy.snackbar.open(`Тара помечена активной`);
        this.handleParamsChange();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: "is-warning",
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        });
      });
  }

  exportAsXLSX() {
    this.$buefy.snackbar.open(
      `Начало экспорта данных. Данная процедура может занять некоторое время.`
    );

    const columnsToExport = this.visibleColumns.map((col: any) => col.id);

    this.$store
      .dispatch(`${STORE_KEY}/exportData`, {
        showColumns: columnsToExport,
        allColumns: this.visibleColumns
      })
      .then((csvContent: any[]) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Каталог продуктов");

        csvContent.forEach((row: any, idx: number) => {
          const _row: any = worksheet.addRow(row);

          _row.eachCell({ includeEmpty: true }, function(
            cell: any,
            colNumber: number
          ) {
            // Форматируем заголовок
            if (idx === 0) {
              cell.style.font = {
                family: 2,
                size: 11,
                bold: true
              };
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF72BF44" }
              };
            }
          });
        });

        // Автоподбор ширины колонок
        worksheet.columns.forEach((column: any) => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: true }, (cell: any) => {
            const columnLength = cell.value ? cell.value.toString().length : 10;
            if (columnLength > maxLength) {
              maxLength = columnLength;
            }
          });
          column.width = maxLength < 10 ? 10 : maxLength + 2;
        });

        workbook.xlsx
          .writeBuffer()
          .then((xls64: any) => {
            const a = document.createElement("a");
            const data = new Blob([xls64], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = URL.createObjectURL(data);
            a.href = url;
            a.download = "catalog_products.xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            }, 0);

            this.$buefy.snackbar.open(
              `Экспорт окончен. Файл должен был скачаться на ваш ПК.`
            );
          })
          .catch((error) => {
            console.error("Export error:", error);
            this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
          });
      })
      .catch((error) => {
        console.error("Export error:", error);
        this.$buefy.snackbar.open(`При экспорте данных произошла ошибка.`);
      });
  }

  async downloadContainerDOCX(product: any) {
    this.$store.dispatch(`${STORE_KEY}/startLoading`);

    try {
      await exportProductSpecDocx(this.specExportOptions(product));
      this.$store.dispatch(`${STORE_KEY}/loadedSuccess`);
      this.$buefy.snackbar.open({
        type: "is-success",
        message: `Шаблон успешно скачан`
      });
    } catch (error) {
      this.$store.dispatch(`${STORE_KEY}/loadedSuccess`);
      console.error("Ошибка при генерации DOCX:", error);
      const message =
        error instanceof Error ? error.message : "Неизвестная ошибка";
      this.$buefy.snackbar.open({
        type: "is-danger",
        message: `Ошибка при генерации DOCX файла: ${message}`
      });
    }
  }

  specExportOptions(product: any, fileName?: string) {
    return createProductSpecExportOptions(
      this as any,
      {
        ...product,
        product_name: product.product_name || product.name,
        type_name: product.parent_type_name || product.type_name || "",
        trade_mark_name:
          product.trade_mark_name || product.parent_product_trade_mark || "",
        technology_name: product.technology_name || "",
        price_segment_name: product.price_segment_name || ""
      },
      fileName || product.name
    );
  }

  async downloadParentProductDOCX(parent: any) {
    this.$store.dispatch(`${STORE_KEY}/startLoading`);

    try {
      await exportProductSpecDocx(this.specExportOptions(parent));
      this.$store.dispatch(`${STORE_KEY}/loadedSuccess`);
      this.$buefy.snackbar.open({
        type: "is-success",
        message: "Шаблон успешно скачан"
      });
    } catch (error) {
      this.$store.dispatch(`${STORE_KEY}/loadedSuccess`);
      console.error("[ProductCatalog.downloadParentProductDOCX] error", error);
      const message =
        error instanceof Error ? error.message : "Неизвестная ошибка";
      this.$buefy.snackbar.open({
        type: "is-danger",
        message: `Ошибка при генерации DOCX файла: ${message}`
      });
    }
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);

    // @ts-ignore
    this.$storage
      .get({ key: "product_catalog_columns" })
      .then((data: any) => {
        let columns = data.value ? JSON.parse(data.value) : [];
        if (!Array.isArray(columns)) {
          columns = [columns];
        }
        const sanitized = this.sanitizeColumnSelection(columns);
        this.showColumns =
          sanitized.length > 0 ? sanitized : [...this.defaultOptionalColumns];
        this.setColumns(this.showColumns);
      })
      .catch(() => {
        this.showColumns = [...this.defaultOptionalColumns];
      });
  }

  setColumns(value: any[]) {
    const sanitized = this.sanitizeColumnSelection(value || []);
    this.showColumns = sanitized;
    // @ts-ignore
    this.$storage.set({
      key: "product_catalog_columns",
      value: JSON.stringify(sanitized)
    });
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store
      .dispatch(`${STORE_KEY}/loadData`, this.$route.query)
      .then(() => {
        this.$store.dispatch(`${STORE_KEY}/loadProductTypes`);
      });
  }

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    if (
      to.name === "product-catalog" &&
      from &&
      from.name &&
      String(from.name).startsWith("product-catalog-")
    ) {
      this.handleParamsChange();
    }
  }
}
